module.exports = __webpack_public_path__ + "static/vf_mshirts_core.b8a7547d.svg";